export default __webpack_public_path__ + "static/media/img-o-n-exchanges.70c5c5de.png";